/**
 * Expands a background-colored div  behind desktop submenu to fake a 100% wide background
 * row for menu.
 */

( function() {
 "use strict";
	var $ = require('jquery');
	// var Sticky = require('sticky-js');
	var fake_menu = $('.header__row--sub-menu');
	// Expand on hover
	$('.menu > .menu__item--parent').on('mouseenter', function() {
		fake_menu.addClass('header__row--visible');
	}).on('mouseleave' , function() {
		fake_menu.removeClass('header__row--visible');
	});

	//If on active parent page, set header__row to be expanded
	var menu_item = $('.menu .menu__item--parent--active, .menu .menu__item--parent.menu__item--active');

	if ( menu_item.hasClass('menu__item--parent--active') ) {
		fake_menu.addClass('header__row--visible-no-trans');
	} else if (menu_item.hasClass('menu__item--active')) {
		fake_menu.addClass('header__row--visible-no-trans');
	}
	// Hide main nav and set subnav to sticky on scroll.

	// On scroll, hide other menu elements when sticky is applied
	$( window ).scroll( function() {
		// if ( menu_item.hasClass('menu__item--parent--active') || menu_item.hasClass('menu__item--active') ) {
		// 	var stickySubmenu = new Sticky('.menu__sub-menu', {
		// 		stickyClass: 'submenu-stuck'
		// 	});
		// 	if ( 0 < $(this).scrollTop()) {
		// 		fake_menu.addClass('notransition');
		// 		fake_menu.removeClass('header__row--visible-no-trans');
		// 	} else {
		// 		fake_menu.removeClass('notransition');
		// 		fake_menu.addClass('header__row--visible-no-trans');
		// 	}
		// }


	});
})();
